import { useQuery } from '@apollo/client'
import { FC } from 'react'
import { findAllPlatforms, findAllPlatformsVariables } from '__generatedTypes__/findAllPlatforms'
import { TAKE_ALL_ITEMS_COUNT } from 'constants/consts'
import { GET_PLATFORMS } from 'queries/common'
import TeamMembersContent from './TeamMembersContent'

const TeamMembers: FC = () => {
  const { data: platformsData } = useQuery<findAllPlatforms, findAllPlatformsVariables>(GET_PLATFORMS, {
    variables: { query: { take: TAKE_ALL_ITEMS_COUNT } },
  })
  const platforms = platformsData?.findAllPlatforms.items
  if (!platforms || platforms.length === 0) {
    return null
  }

  return <TeamMembersContent platforms={platforms} />
}

export default TeamMembers
